import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export default function useQuery(): URLSearchParams {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}